// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/projects.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/projects.proto.
 */
export const file_pull_requests_v1_projects: GenFile = /*@__PURE__*/
  fileDesc("Ch9wdWxsX3JlcXVlc3RzL3YxL3Byb2plY3RzLnByb3RvEhdnaXRodWIucHVsbF9yZXF1ZXN0cy52MSJRChBQcm9qZWN0c1Jlc3BvbnNlEj0KCHByb2plY3RzGAEgAygLMisuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUHVsbFJlcXVlc3RQcm9qZWN0IssBChJQdWxsUmVxdWVzdFByb2plY3QSCgoCaWQYASABKAkSDQoFdGl0bGUYAiABKAkSDgoGbnVtYmVyGAMgASgFEgsKA3VybBgEIAEoCRIOCgZjbG9zZWQYBSABKAgSDwoHaXRlbV9pZBgGIAEoCRIZChF2aWV3ZXJfY2FuX3VwZGF0ZRgHIAEoCBJBCgZzdGF0dXMYCCABKAsyMS5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5QdWxsUmVxdWVzdFByb2plY3RTdGF0dXMiiQEKGFB1bGxSZXF1ZXN0UHJvamVjdFN0YXR1cxIQCghmaWVsZF9pZBgBIAEoCRIRCglvcHRpb25faWQYAiABKAkSSAoHb3B0aW9ucxgDIAMoCzI3LmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLlB1bGxSZXF1ZXN0UHJvamVjdFN0YXR1c09wdGlvbiI6Ch5QdWxsUmVxdWVzdFByb2plY3RTdGF0dXNPcHRpb24SCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCWIGcHJvdG8z");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/projects
 *
 * Defined by PullRequests::PageData::SharedController#projects.
 *
 * @generated from message github.pull_requests.v1.ProjectsResponse
 */
export type ProjectsResponse = Message<"github.pull_requests.v1.ProjectsResponse"> & {
  /**
   * The Projects (v2) this pull request is currently linked to.
   *
   * @generated from field: repeated github.pull_requests.v1.PullRequestProject projects = 1;
   */
  projects: PullRequestProject[];
};

/**
 * Describes the message github.pull_requests.v1.ProjectsResponse.
 * Use `create(ProjectsResponseSchema)` to create a new message.
 */
export const ProjectsResponseSchema: GenMessage<ProjectsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 0);

/**
 * @generated from message github.pull_requests.v1.PullRequestProject
 */
export type PullRequestProject = Message<"github.pull_requests.v1.PullRequestProject"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: int32 number = 3;
   */
  number: number;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: bool closed = 5;
   */
  closed: boolean;

  /**
   * @generated from field: string item_id = 6;
   */
  itemId: string;

  /**
   * Whether the viewer has write access to this project, and so can change
   * its fields (e.g. status) for this item.
   *
   * @generated from field: bool viewer_can_update = 7;
   */
  viewerCanUpdate: boolean;

  /**
   * The project's "Status" single-select field and its value for this item,
   * if the project has one.
   *
   * @generated from field: github.pull_requests.v1.PullRequestProjectStatus status = 8;
   */
  status?: PullRequestProjectStatus;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProject.
 * Use `create(PullRequestProjectSchema)` to create a new message.
 */
export const PullRequestProjectSchema: GenMessage<PullRequestProject> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 1);

/**
 * @generated from message github.pull_requests.v1.PullRequestProjectStatus
 */
export type PullRequestProjectStatus = Message<"github.pull_requests.v1.PullRequestProjectStatus"> & {
  /**
   * Database id of the "Status" single-select field
   *
   * @generated from field: string field_id = 1;
   */
  fieldId: string;

  /**
   * Id of the currently selected option, if any.
   *
   * @generated from field: string option_id = 2;
   */
  optionId: string;

  /**
   * Options available to select from.
   *
   * @generated from field: repeated github.pull_requests.v1.PullRequestProjectStatusOption options = 3;
   */
  options: PullRequestProjectStatusOption[];
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProjectStatus.
 * Use `create(PullRequestProjectStatusSchema)` to create a new message.
 */
export const PullRequestProjectStatusSchema: GenMessage<PullRequestProjectStatus> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 2);

/**
 * @generated from message github.pull_requests.v1.PullRequestProjectStatusOption
 */
export type PullRequestProjectStatusOption = Message<"github.pull_requests.v1.PullRequestProjectStatusOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestProjectStatusOption.
 * Use `create(PullRequestProjectStatusOptionSchema)` to create a new message.
 */
export const PullRequestProjectStatusOptionSchema: GenMessage<PullRequestProjectStatusOption> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_projects, 3);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ProjectsResponseSchema, "716a5b30f718")
registerSchemaHash(PullRequestProjectSchema, "3455ae2737d5")
registerSchemaHash(PullRequestProjectStatusSchema, "72e02ee87a72")
registerSchemaHash(PullRequestProjectStatusOptionSchema, "826ff9c94d4d")
